import React from "react";
import GenericModal from "../../common/genericModal";
import styles from "./Transection.module.scss";
import { Link } from "react-router-dom";

const Transaction = ({ isOpen, toggle }) => {
  const changeHandler = () => {};
  return (
    <>
      <GenericModal isOpen={isOpen} toggle={toggle}>
        <div className={styles.wrapper}>
          <div className={styles.mainheading}>Transaction Detail</div>
          <div className={styles.row1}>
            <div className={styles.lefttext}>Date</div>
            <div className={styles.righttext}>06-07-2021</div>
          </div>
          <div className={styles.row1}>
            <div className={styles.lefttext}>Type</div>
            <div className={styles.righttext}>Receive BTC</div>
          </div>
          <div className={styles.row1}>
            <div className={styles.lefttext}>Sending Address</div>
            <div className={styles.righttext}>0x326...3d7</div>
          </div>
          <div className={styles.row1}>
            <div className={styles.lefttext}>Amount</div>
            <div className={styles.righttext}>1BTC </div>
          </div>
          <div className={styles.row1}>
            <div className={styles.lefttext}>Processing fee</div>
            <div className={styles.righttext}>$2.00 </div>
          </div>

          <div className={styles.row1}>
            <div className={styles.lefttext}>Crypto fee</div>
            <div className={styles.righttext}>$2.00 </div>
          </div>

          <div className={styles.row1}>
            <div className={styles.lefttext}>Received Amount</div>
            <div className={styles.righttext}>0.999999 BTC</div>
          </div>

          <div className={styles.row1}>
            <div className={styles.lefttext}>Status </div>
            <div className={styles.righttext1}>Completed</div>
          </div>
        </div>
      </GenericModal>
    </>
  );
};

export default Transaction;
